module.exports = __webpack_public_path__ + "img/email.05d8277a.svg";